import { createContext } from 'react';
const ChatWidgetLocaleContext = /*#__PURE__*/createContext(undefined);
export const ChatWidgetLocaleContextConsumer = ChatWidgetLocaleContext.Consumer;
export const ChatWidgetLocaleContextProvider = ChatWidgetLocaleContext.Provider;